import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Bandeau « consultation seule ».
 *
 * <p>Depuis que les droits distinguent lire et modifier, un écran peut
 * s'ouvrir sans que ses boutons d'écriture aient un sens. Les retirer sans
 * rien dire laisse croire à une panne : ce bandeau dit pourquoi ils manquent.
 * Un seul composant pour tous les écrans — la phrase et la forme sont les
 * mêmes partout.</p>
 *
 * <p>L'écran décide lui-même s'il l'affiche, par son `canWrite` : ce composant
 * ne lit pas le jeton.</p>
 */
@Component({
  selector: 'app-read-only-notice',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <p class="ro-notice" role="status">
      <i class="fa-solid fa-eye" aria-hidden="true"></i>
      <span>
        <b>{{ 'COMMON.READ_ONLY' | translate }}</b>
        {{ messageKey | translate }}
      </span>
    </p>
  `,
  styleUrl: './read-only-notice.component.css',
})
export class ReadOnlyNoticeComponent {
  /** Clé i18n de la phrase qui suit le titre. */
  @Input() messageKey = 'COMMON.READ_ONLY_HINT';
}
